/* eslint-disable no-unused-vars */

import React from "react";
import ReactDOM from "react-dom";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import store from "store2";
import { SnackbarProvider } from "notistack";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const echoObject = {
  broadcaster: "pusher",
  key: "6bd34a33feb533839584",
  cluster: "ap1",
  authEndpoint: `${process.env.REACT_APP_API_BASE_URL}/broadcasting/auth`,
};

const token = store.session.get("token");
if (token) {
  echoObject.auth = {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
}

window.Echo = new Echo(echoObject);

if (process.env.NODE_ENV !== "development") {
  // disable console.log if not on development mode
  console.log = () => {};
}

const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};

ReactDOM.render(
  <React.Fragment>
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={5}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
    >
      <App />
    </SnackbarProvider>
  </React.Fragment>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
